<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" href="/"> RaiseTrack</a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav ml-auto">
        <li v-if="isLoggedIn" class="nav-item">
          <a class="nav-link" href="/dashboard">View campaigns </a>
        </li>
        <li v-if="isLoggedIn" class="nav-item">
          <a class="nav-link" href="/new/campaign">New Campaign </a>
        </li>
        <li v-if="isLoggedIn" class="nav-item">
          <a class="nav-link" href="/shuffle">Shuffle </a>
        </li>

        <div v-if="isLoggedIn" class="dropdown">
          <a class="dropdown-item" href="#" @click="handleLogout">Logout</a>
        </div>
      </ul>
    </div>
  </nav>
</template>
<style scoped>
.navbar .login-btn {
  position: absolute;
  top: 0px;
  right: 15px;
}
@media (max-width: 767px) {
  .navbar .login-btn {
    right: 75px;
  }
}
</style>

<script>
export default {
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
  },
  methods: {
    handleLogout() {
      // this.$store.dispatch("clearToken");
      localStorage.removeItem("new_token"); // clear your user's token from localstorage
      localStorage.removeItem("new_user"); // clear your user from localstorage
      // localStorage.clear();

      this.$router.push("/login");
    },
  },
  data() {
    return {
      user: "",
    };
  },
  created() {

    const userData = localStorage.getItem('user');
  
  if (userData) {
    try {
      this.user = JSON.parse(userData);
      console.log(this.user)
    } catch (e) {
      console.error('Failed to parse user data:', e);
      this.user = null;
    }
  } else {
    console.warn("User not found in localStorage");
    this.user = null;
  }


    // let user = localStorage.getItem("user");
  //   async function getUser() {
  //     // Get user from localStorage
  //     let user = localStorage.getItem("user");

  //     if (!user) {
  //       // Default user object with an ID
  //       const defaultUser = { id: 1, name: "Guest", role: "visitor" };
  //       localStorage.setItem("user", JSON.stringify(defaultUser)); // Store default user
  //       user = defaultUser; // Use default user
  //     } else {
  //       // Parse the stored JSON string back into an object
  //       try {
  //         user = JSON.parse(user);

  //         // Ensure the parsed user has an `id` field
  //         if (!user.id) {
  //           user.id = Date.now(); // Assign a unique ID if missing
  //           localStorage.setItem("user", JSON.stringify(user)); // Update localStorage
  //         }
  //       } catch (error) {
  //         console.error("Error parsing user from localStorage:", error);

  //         // Reset to default user in case of error
  //         const defaultUser = { id: 1, name: "Guest", role: "visitor" };
  //         localStorage.setItem("user", JSON.stringify(defaultUser));
  //         user = defaultUser;
  //       }
  //     }

  //     return user;
  //   }

  //   (async () => {
  //     const user = await getUser(); // Await the function
  //     setInterval(() => {
  //       this.handleLogout();
  //     }, 600000);
  //     console.log(user); // Log the user object
  //   })();

  //   // Parse the user back to an object if needed
  //   // user = JSON.parse(user);
  //   //     this.user = JSON.parse(user);
  //   //     console.log(this.user.name)

  //   //     setInterval(() => {
  //   //       this.handleLogout();
  //   //     }, 600000);
  // },
}
}
</script>
